import { Controller } from 'stimulus'

const parseNum = (value) => {
  const parsed = parseFloat(String(value).replace(",", "."))
  return Number.isFinite(parsed) ? parsed : 0
}

const round = (value) => Math.round(value * 100) / 100

export default class extends Controller {

  static targets = ['purchasePrice', 'unitPrice', 'coefficient']

  connect() {
    this.refreshCoefficient()
  }

  onPurchasePriceChange() {
    const coefficient = parseNum(this.coefficientTarget.value)
    if (coefficient <= 0) return this.refreshCoefficient()

    const purchasePrice = parseNum(this.purchasePriceTarget.value)
    this.unitPriceTarget.value = round(purchasePrice * coefficient)
  }

  onUnitPriceChange() {
    const coefficient = parseNum(this.coefficientTarget.value)
    if (coefficient <= 0) return this.refreshCoefficient()

    const unitPrice = parseNum(this.unitPriceTarget.value)
    this.purchasePriceTarget.value = round(unitPrice / coefficient)
  }

  onCoefficientChange() {
    const purchasePrice = parseNum(this.purchasePriceTarget.value)
    if (purchasePrice <= 0) return

    const coefficient = parseNum(this.coefficientTarget.value)
    this.unitPriceTarget.value = round(purchasePrice * coefficient)
  }

  refreshCoefficient() {
    const purchasePrice = parseNum(this.purchasePriceTarget.value)
    const unitPrice     = parseNum(this.unitPriceTarget.value)
    if (purchasePrice <= 0) return

    this.coefficientTarget.value = round(unitPrice / purchasePrice)
  }
}
